import React from "react";
import Message from "../Components/Colaboradores/Message";
import Footer from "../Components/Commons/Footer";
import logoPossumus from "../Assets/Logo_Possumus.svg";
import "../css/layout.css";

import AOS from "aos";
import { useColaboradoresContext } from "../contexts/Colaboradores";

const Home = () => {
  const { colaboradores, searchValue, setSearchValue } =
    useColaboradoresContext();
  const url = "/firma/";

  AOS.init({});

  return (
    <>
      <div id="contentColaboradores">
        <div id="contentLogo">
          <img src={logoPossumus} alt="Possumus"></img>
        </div>

        <h1>A continuación, vas a encontrar tu firma.</h1>
        <div id="contentSearch">
          <h3>
            Ingresá tu nombre y hace click en
            <strong> "Ver firma"</strong> para acceder a tu firma.
          </h3>
          <input
            type="text"
            name="search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Buscar"
            className="searchField"
          />
        </div>

        <div className="contentList">
          <div className="list">
            <h2>
              Colaboradores
              <span>
                <a
                  href="https://possumussr.sharepoint.com/sites/Staff/Documentos%20compartidos/Forms/AllItems.aspx?ga=1&id=%2Fsites%2FStaff%2FDocumentos%20compartidos%2FInstitucional%2FFirma%20Email%2FFirma%20html%2FTutorial%2FTutorial%20Firmas%2Epdf&parent=%2Fsites%2FStaff%2FDocumentos%20compartidos%2FInstitucional%2FFirma%20Email%2FFirma%20html%2FTutorial"
                  target="_blank"
                  rel="noreferrer"
                  className="btnPrincipal"
                >
                  Como configurar tu firma
                </a>
              </span>
            </h2>
            <div className="contentCards">
              {colaboradores
                .filter((colaborador) =>
                  colaborador.Nombre.match(new RegExp(searchValue, "i"))
                )
                .map((colaborador) => {
                  return (
                    <div
                      key={colaborador.id}
                      className="cards"
                      data-aos="fade-up"
                      data-aos-offset="100"
                      data-aos-duration="1000"
                      data-aos-easing="ease-in-sine"
                    >
                      <div className="contentTitleCards">
                        <h4>{colaborador.Nombre} </h4>
                        <h5>{colaborador.Puesto} </h5>
                        <p>{colaborador.Email} </p>
                      </div>
                      <div className="contentButtonFirma">
                        <div style={{ width: "100%" }}>
                          <a
                            href={url + colaborador.slug}
                            target="_blank"
                            rel="noreferrer"
                            style={{}}
                          >
                            <p>Ver Firma</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      <Message></Message>
      <Footer></Footer>
    </>
  );
};

export default Home;
